<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-unfreeze`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M41.778 4C43.005 4 44 4.995 44 6.222v35.556A2.222 2.222 0 0141.778 44H6.222A2.222 2.222 0 014 41.778V6.222C4 4.995 4.995 4 6.222 4h35.556zM40 8H8v32h10v-3a1 1 0 011-1h3a1 1 0 011 1v3h17V23h-3a1 1 0 01-1-1v-3a1 1 0 011-1h3V8zM22 27a1 1 0 011 1v3a1 1 0 01-1 1h-3a1 1 0 01-1-1v-3a1 1 0 011-1h3zm0-9a1 1 0 011 1v3a1 1 0 01-1 1h-3a1 1 0 01-1-1v-3a1 1 0 011-1h3zm9 0a1 1 0 011 1v3a1 1 0 01-1 1h-3a1 1 0 01-1-1v-3a1 1 0 011-1h3z"/></svg>
</template>
<script>

export default {
  name: 'IconUnfreeze',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
